<template>
  <div class="chatbot-container">
    <!-- モーダルターゲット START -->
    <ModalCreateChatBot ref="create"/>
    <!-- モーダルターゲット END   -->
    <ChatBotCreateHeader
      @createChatBot="createChatBot"/>
    <h2 class="koyo-title">
      <b>ロボを雇用する</b>
    </h2>
    <p class="koyo-desc">ロボの作成が難しいと感じる方向けに下記カテゴリからカンタンに雇用が可能です。</p>
    <template v-if="!isSearchList">
      <template
        v-for="(category, cIdx) in storeCategory">
        <div
          class="-container"
          :key="cIdx + 'cate-store'"
          v-if="storesInCategory(category).length > 3">
          <div class="chatbot-label">
            {{category.category_title}}<br>
            <span style="font-size: 16px; font-weight: 500; color: #666;">
              {{category.category_desc}}
            </span>
          </div>
          <div class="loop-box">
            <ChatBotCard
              v-for="(cb, idx) in storesInCategory(category)"
              :key="idx + '-store'"
              class="loop-child"
              scale="is-medium"
              uses="store"
              :chatbot="cb"
              :category="category"
              :userChatBotBookMark="userChatBotBookMark"
              :users="users"
              :user="user"
              :sitemapRootList="sitemapRootList"
              :sitemapEmploymentList="sitemapEmploymentList"
              :usersStatusAPI="usersStatusAPI"
              @cbUrlSetting="cbUrlSetting(chatbot)"
              @setIcon="setIcon"
              @changeBookMark="changeBookMark"
              @movePartsEdit="movePartsEdit"
              @updateChatBot="updateChatBot"
              @deleteChatBot="deleteChatBot"
              @clickCreateChatBot="clickCreateChatBot"/>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ChatBotCreateHeader from '@/views/DashBoard/ChatBot/ChatBotCreateHeader'
import ChatBotCard from '@/views/DashBoard/ChatBot/ChatBotCard'
import ModalCreateChatBot from '@/components/ui/ModalCreateChatBot'
import alterReplace from '@/functions/alterStrReplace'
import createUUID from '@/functions/createUUID'

export default {
  name: 'ChatBotList',
  componentName: 'ChatBotList',
  components: {
    ChatBotCreateHeader,
    ChatBotCard,
    ModalCreateChatBot,
    alterReplace,
  },
  computed: {
    ...mapState('auth', ['user', 'users', 'userChatBotBookMark', 'storeCategory', 'usersStatusAPI']),
    ...mapState('chatbot', ['chatbots', 'stores', 'copyScenarioTable']),
    ...mapState('employmentPage', ['contents']),
    ...mapState('mediapool', ['images']),
    ...mapState('sitemap', ['sitemapRootList', 'sitemapEmploymentList']),
    storesInCategory () {
      return function (category) {
        let storeList = []
        for (const store of this.stores) {
          if (category.category_id == store.category) {
            storeList.push(store)
          }
        }
        return storeList
      }
    },
  },
  data () {
    return {
      search: null,
      pages: 1,
      isRecruitPage: false,
      deleteIndex: null,
      isArchiveList: false,
      isSearchList: false,
    }
  },
  methods: {
    changeArchiveList (flg) {
      this.isArchiveList = flg
    },
    createChatBot () {
      this.$refs.create.isCardModalActive = true
    },
    searchChatBot (data) {
      this.isSearchList = data.flg
      this.search = data.search
    },
    // ロボが起動しているかどうか
    isOnBot (chatbot) {
      // ロボの起動設定チェック
      if (!chatbot.chatbot_mini) {
        // ミニロボを持っていない場合
        for (const root of this.sitemapRootList) {
          for (const sitemap of root.node_list) {
            for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
              if (robo.data.bot_id === chatbot.bot_id) {
                return true
              }
            }
          }
        }
        for (const employment of this.sitemapEmploymentList) {
          for (const robo of employment.apply_robo_list.concat(employment.apply_minirobo_list)) {
            if (robo.data.bot_id === chatbot.bot_id) {
              return true
            }
          }
        }
      } else if (chatbot.chatbot_mini.length < 1) {
        // ミニロボを持っていない場合
        for (const root of this.sitemapRootList) {
          for (const sitemap of root.node_list) {
            for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
              if (robo.data.bot_id === chatbot.bot_id) {
                return true
              }
            }
          }
        }
        for (const employment of this.sitemapEmploymentList) {
          for (const robo of employment.apply_robo_list.concat(employment.apply_minirobo_list)) {
            if (robo.data.bot_id === chatbot.bot_id) {
              return true
            }
          }
        }
      } else {
        // ミニロボを持っている場合
        for (const mini of chatbot.chatbot_mini) {
          for (const root of this.sitemapRootList) {
            for (const sitemap of root.node_list) {
              for (const robo of sitemap.apply_robo_list.concat(sitemap.apply_minirobo_list)) {
                if (robo.data.bot_id === chatbot.bot_id) {
                  return true
                }
              }
            }
          }
          for (const employment of this.sitemapEmploymentList) {
            for (const robo of employment.apply_robo_list.concat(employment.apply_minirobo_list)) {
              if (robo.data.bot_id === mini.bot_id) {
                return true
              }
            }
          }
        }
      }
      return false
    },
    // ミニロボ有無チェック
    isMiniBot (chatbot) {
      let isMini = false
      if (chatbot.chatbot_mini) {
        if (chatbot.chatbot_mini.length > 0) {
          isMini = true
        }
      }
      return isMini
    },
    // お気に入り更新
    changeBookMark (bot) {
      let bkCB = null
      this.isBKMKLoading = true
      for (const cb of this.userChatBotBookMark) {
        if (cb.chatbot === bot.bot_id) {
          bkCB = cb
          break
        }
      }
      if (bkCB) {
        this.$store.dispatch('auth/deleteUserChatBotBookMark', bkCB.pk)
      } else {
        let cbTemp = {
          chatbot: bot.bot_id,
          user: this.user.userHash
        }
        this.$store.dispatch('auth/createUserChatBotBookMark', cbTemp)
      }
    },
    // ICON 更新
    setIcon (data) {
      // ミニロボの画像変更とそれ以外
      if (data.miniIdx >= 0) {
        let updateChatBotMiniTemp = data.chatbot.chatbot_mini[this.miniIdx]
        for (const i of this.images) {
          if (i.image_id == data.id) {
            updateChatBotMiniTemp["icon_ref"] = i.pk
            updateChatBotMiniTemp["icon_data"] = i.image_data
            this.$store.dispatch('chatbot/updateChatBotMini', updateChatBotMiniTemp)
            break
          }
        }
      } else {
        this.$store.dispatch('chatbot/setChatBotIcon', {
          name: data.chatbot.name,
          id: data.chatbot.bot_id,
          image_id: data.id
        })
      }
    },
    // シナリオ編集画面へ
    movePartsEdit (chatbot) {
      this.$store.dispatch('chatbot/setScenarioTitleBeforeChange', '')
      this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: chatbot.scenario_name })
      this.$store.dispatch('chatbot/selectChatbot', chatbot)
      this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + chatbot.scenario_name)
    },
    // ロボ更新
    updateChatBot (chatbot) {
      this.$store.dispatch('chatbot/setChatBot', chatbot)
    },
    // ロボ削除
    deleteChatBot (chatbot) {
      this.$refs.delete.chatBotDeleteFlag = true
      this.deleteIndex = chatbot.bot_id
    },
    // URL設定
    cbUrlSetting (cb) {
      if (cb.chatbot_mini.length === 0) {
        this.cbInfo = cb
        this.isURLSetting = true
      } else {
        alert('ミニロボを出動させるには「ミニロボリスト ＞　配置設定」より設定をお願いいたします。')
        this.showInfoView(cb)
      }
    },
    // タグ設定
//    createChatBotTags (data) {
//      if (!data.tag) {
//        return
//      } else {
//        for (const t of data.chatbot.chatbot_tag) {
//          if (t.name === data.tag.pk) {
//            alert('同一のタグ名が既に登録されております。')
//            return
//          }
//        }
//      }
//      let temp = {
//        name: data.tag,
//        company: this.user.companyPK
//      }
//      this.$store.dispatch('chatbot/createChatBotTag', temp)
//    },
//    // タグ削除
//    deleteChatBotTags (data) {
//      this.$store.dispatch('chatbot/deleteChatBotTag', data.tag.pk)
//    },
    // ロボインストール
    clickCreateChatBot (bot) {
      let isAdd = confirm('ロボを雇用しますか？')
      if (isAdd) {
        this.$store.dispatch('chatbot/selectTemplate', bot)
        let inputs = {}
        inputs.scenario_name = createUUID()
        inputs.group = this.user.companyID
        inputs.is_store = false
        inputs.name = bot.name
        let createChatbotTemp = inputs
        this.$store.dispatch('chatbot/copyScenarioTable')
        this.$store.dispatch('chatbot/createChatBot', inputs)
          .then((d) => {
            if (this.copyScenarioTable.length > 0) {
              this.$store.dispatch('chatbot/importScenarioList', {scenarioName: inputs.scenario_name, scenarioTable: this.copyScenarioTable})
            }
            setTimeout(() => {
              console.debug('import after reload')
              this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: inputs.scenario_name })
              let cb = ''
              for (let chatbot of this.chatbots) {
                if (chatbot.scenario_name ==  inputs.scenario_name) {
                  cb = chatbot
                }
              }
              this.$store.dispatch('chatbot/selectChatbot', cb)
              this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + inputs.scenario_name)
            }, 700)
          })
      } else {
        alert('キャンセルしました')
      }
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.chatbot-container {
  height: 100%;
  width: 100%;
  overflow: auto;
}

.koyo-title {
  text-align: left; font-size: 24px; padding-left: 20px;
  margin-top: 16px;
}
.koyo-desc {
  text-align: left; padding-left: 20px;
  margin-bottom: 16px;
}

.-container {
  width : 100%;
  padding: 16px 24px;
}

.scroll-box {
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  text-align: left;
  -webkit-overflow-scrolling: touch;
  .no-chatbot {
    padding: 8px;
  }
}
.scroll-box::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.loop-box {
  overflow-x: auto;
  white-space: nowrap;
  text-align: left;
  -webkit-overflow-scrolling: touch;
}
.loop-box::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.chatbot-label {
  text-align: left;
  font-weight: 600;
  font-size: 20px;
  display: block;
  border-left: solid 16px #162c5d;
  padding-left: 8px;
  margin-bottom: 8px;
}
.attend-title {
  display: flex;
  align-items: center;
  .attend {
    display: flex;
    align-items: center;
    span {
      font-size: 16px;
    }
    p {
      margin-left: 8px;
    }
  }
  .exist {
    margin-left: 36px;
  }
  .not-exist {
    margin-left: 16px;
    color: grey;
  }
}

@-webkit-keyframes loop {
  0% {
    -webkit-transform: translateX(1000%);
    -ms-transform:     translateX(1000%);
    transform:         translateX(1000%);
  }
  to {
    -webkit-transform: translateX(-1000%);
    -ms-transform:     translateX(-1000%);
    transform:         translateX(-1000%);
  }
}

@keyframes loop {
  0% {
    -webkit-transform: translateX(1000%);
    -ms-transform:     translateX(1000%);
    transform:         translateX(1000%);
  }
  to {
    -webkit-transform: translateX(-1000%);
    -ms-transform:     translateX(-1000%);
    transform:         translateX(-1000%);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/ChatBot/ChatBotCreateView.vue